import { isEmpty } from 'lodash';

const checkFilterInformation = (data) => {
    const { dc, groupType, custGroup, parahub, dateSellout, dateUpload } = data;

    return (
        !isEmpty(dc) ||
        !isEmpty(groupType) ||
        !isEmpty(custGroup) ||
        !isEmpty(parahub) ||
        !isEmpty(dateSellout) ||
        !isEmpty(dateUpload)
    );
};

export default checkFilterInformation;
